/* LP Landing Page — shared behavior for all lp-* sections */
(function () {
  'use strict';

  function scrollToAnchor(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var nav = document.querySelector('.plp-tabnav');
    var offset = nav ? nav.offsetHeight + 4 : 0;
    var y = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }

  function initScrollButtons(scope) {
    scope.querySelectorAll('[data-plp-scroll]').forEach(function (btn) {
      if (btn.dataset.plpInit) return; btn.dataset.plpInit = '1';
      btn.addEventListener('click', function () { scrollToAnchor(btn.dataset.plpScroll); });
    });
  }

  function initTabnav(scope) {
    scope.querySelectorAll('.plp-tabnav').forEach(function (nav) {
      if (nav.dataset.plpInit) return; nav.dataset.plpInit = '1';
      var links = Array.prototype.slice.call(nav.querySelectorAll('.plp-tabnav__link'));
      links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          scrollToAnchor(link.dataset.plpAnchor);
        });
      });
      var strip = nav.querySelector('.plp-tabnav__scroll');
      var lastActive = null;
      var ticking = false;
      var spy = function () {
        ticking = false;
        var targets = links.map(function (l) { return document.getElementById(l.dataset.plpAnchor); }).filter(Boolean);
        if (!targets.length) return;
        var navH = nav.offsetHeight;
        var current = targets[0].id;
        targets.forEach(function (t) {
          if (t.getBoundingClientRect().top - navH - 60 <= 0) current = t.id;
        });
        if (current === lastActive) return; /* nothing changed — do nothing */
        lastActive = current;
        links.forEach(function (l) {
          var on = l.dataset.plpAnchor === current;
          l.classList.toggle('is-active', on);
          if (on && strip) {
            /* keep the active tab visible by scrolling ONLY the nav strip
               horizontally — never scrollIntoView, which also scrolls the page */
            var target = l.offsetLeft - (strip.clientWidth - l.offsetWidth) / 2;
            strip.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
          }
        });
      };
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; window.requestAnimationFrame(spy); }
      }, { passive: true });
      window.requestAnimationFrame(spy);
    });
  }

  function initGalleries(scope) {
    scope.querySelectorAll('.plp-gallery').forEach(function (gallery) {
      if (gallery.dataset.plpInit) return; gallery.dataset.plpInit = '1';
      var track = gallery.querySelector('.plp-gallery__track');
      var slides = gallery.querySelectorAll('.plp-gallery__slide');
      var dotsWrap = gallery.querySelector('.plp-gallery__dots');
      if (!track || !slides.length || !dotsWrap) return;
      dotsWrap.innerHTML = '';
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'plp-gallery__dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to image ' + (i + 1) + ' of ' + slides.length);
        d.addEventListener('click', function () {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
        });
        dotsWrap.appendChild(d);
      });
      var dots = dotsWrap.querySelectorAll('.plp-gallery__dot');
      var sync = function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      };
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      var next = gallery.querySelector('.plp-gallery__next');
      if (next) next.addEventListener('click', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        track.scrollTo({ left: slides[(i + 1) % slides.length].offsetLeft, behavior: 'smooth' });
      });
    });
  }

  function initInfotabs(scope) {
    scope.querySelectorAll('.plp-infotabs').forEach(function (widget) {
      if (widget.dataset.plpInit) return; widget.dataset.plpInit = '1';
      widget.querySelectorAll('.plp-infotabs__tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var n = tab.dataset.plpTab;
          widget.querySelectorAll('.plp-infotabs__tab').forEach(function (t) {
            var on = t.dataset.plpTab === n;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          widget.querySelectorAll('.plp-infotabs__panel').forEach(function (p) {
            p.classList.toggle('is-active', p.dataset.plpPanel === n);
          });
        });
      });
    });
  }

  function initIngredients(scope) {
    scope.querySelectorAll('.plp-ingredient__expand').forEach(function (btn) {
      if (btn.dataset.plpInit) return; btn.dataset.plpInit = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('.plp-ingredient');
        var open = card.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initFaq(scope) {
    scope.querySelectorAll('.plp-faq__q').forEach(function (btn) {
      if (btn.dataset.plpInit) return; btn.dataset.plpInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.plp-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initReviews(scope) {
    scope.querySelectorAll('[data-plp-more]').forEach(function (btn) {
      if (btn.dataset.plpInit) return; btn.dataset.plpInit = '1';
      btn.addEventListener('click', function () {
        var sec = btn.closest('.plp');
        (sec || document).querySelectorAll('.plp-review--hidden').forEach(function (r) {
          r.classList.remove('plp-review--hidden');
        });
        btn.parentElement.style.display = 'none';
      });
    });
  }

  function initSticky(scope) {
    scope.querySelectorAll('.plp-stickybar').forEach(function (bar) {
      if (bar.dataset.plpInit) return; bar.dataset.plpInit = '1';
      var onScroll = function () {
        var hero = document.querySelector('.plp-hero');
        var show = hero ? hero.getBoundingClientRect().bottom < 0 : window.pageYOffset > 600;
        bar.classList.toggle('is-visible', show);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  }

  function initAll(scope) {
    scope = scope || document;
    initScrollButtons(scope);
    initTabnav(scope);
    initGalleries(scope);
    initInfotabs(scope);
    initIngredients(scope);
    initFaq(scope);
    initReviews(scope);
    initSticky(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  /* Re-init when the theme editor reloads a section */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
